import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from 'components/CustomButtons/Button.js';
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { getFiles, sendFile, getAllFiles } from 'services/lockers/lockers';

import Card from 'components/Card/Card.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardBody from 'components/Card/CardBody.js';
import CardFooter from 'components/Card/CardFooter.js';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Table from "components/Table/Table.js";

import Input from '@material-ui/core/Input';

import Circular from '../Circular/Circular';

import { Divider, TablePagination, TextField } from '@material-ui/core';
import { uploadFile } from 'services/file';
import { createRabbitPayload } from 'services/actions/actions';
import { sendRabbitCommand } from 'services/actions/actions';

import { Send } from '@material-ui/icons';
import moment from 'moment';


const useStyles = theme => ({
    formControl: {
        margin: theme.spacing(2),
        minWidth: 400,
        '& label.Mui-focused': {
            color: 'green'
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'green',
        },
    },
    inputText: {
        minWidth: "100% !important"
    },
    rootCircular: {
        flexGrow: 1,
        backgroundColor: "#f1f1f2"
    },
    iconView: {
        color: "white !important"
    },
    alItems: {
        display: "flex",
        // alignItems: "baseline"
    },
    note: {
        lineHeight: '0.3em'
    }
});

class File extends Component {

    state = {
        open: false,
        fileType: null,
        openSnackbar: false,
        success: "danger",
        message: "",
        function: {},
        files: [],
        url: null,
        fileName: null,
        circular: false,
        page: 0,
        rowsPerPage: 10

    }

    componentDidMount() {

        this.handleFileRefresh();
    }


    handleClose = () => {
        this.setState({ open: false, openSnackbar: false });
    }

    handleOpen = () => {
        this.setState({ open: true });
    }

    handleChange = (event) => {
        // const e = event.target.id ? event.target.id : event.target.name;
        const e = event.target.name;
        const { value } = event.target;

        switch (e) {
            case "fileType":
                this.setState({ fileType: value })
                break;
            case "url":
                this.setState({ url: value })
                break;
            case "fileName":
                this.setState({ fileName: value })
                break;
        }
    }

    handleFileChange = async (e) => {

        let files = e.target.files || e.dataTransfer.files
        if (!files.length) return


        if (files) {
            const resposta = await uploadFile(files[0]);
            this.setState({ url: encodeURI(resposta?.url) })
            console.log("=========>", JSON.stringify(resposta));
        }
    };

    updateFilesView = () => {

    }

    handleUpload = () => {
        this.setState({ circular: true })

        getFiles(this.props.lockerId, this.state.fileType, (resp) => {

            this.handleFileRefresh();

        });
    }

    formatDate = (date) => {
        let dateArray = date.split('T');
        let data = dateArray[0];
        let time = dateArray[1];

        let anoMesDia = data.split('-');
        let horaMinutos = time.substring(0, 5);


        // return `${anoMesDia[2]}/${anoMesDia[1]}/${anoMesDia[0]} ${horaMinutos}`;

        return moment(date).local().format('DD/MM/YYYY HH:mm:SS');
    }

    handleDownload = () => {

        // const payploadBase = {
        //     url: this.state.url,
        //     fileName: this.state.fileName
        // }

        // const payload = createRabbitPayload(this.props.lockerId, "FILE_DOWNLOAD", payploadBase)
        // console.log('Payload: ', JSON.stringify(payload));

        // sendRabbitCommand(payload, (resp) => {
        //     if (resp) {
        //         this.setState({ message: 'Arquivo enviado com sucesso!', success: 'success' });
        //     } else {
        //         this.setState({ message: 'OPS! Erro ao enviar o arquivo', success: 'danger' });
        //     }
        //     this.setState({ openSnackbar: true });
        // });

        sendFile(this.props.lockerId, this.state.url, this.state.fileName, (resp) => {
            if (resp.status == 200) {
                this.setState({ message: 'Arquivo enviado com sucesso!', success: 'success' });
            } else {
                this.setState({ message: 'OPS! Erro ao enviar o arquivo', success: 'danger' });
            }

            this.handleFileRefresh();

            this.setState({ openSnackbar: true })
        })
    }

    handleResend = (arquivo) => {

        this.setState({
            url: arquivo.url,
            fileName: arquivo.fileName
        })
        
    }

     handleChangePage = (event, newPage) => {
        this.setState({page: newPage})
      };
    
    handleChangeRowsPerPage = (event) => {
        this.setState({page: 0, rowsPerPage: parseInt(event.target.value, 10)})
      };


    handleFileRefresh = () => {
        getAllFiles(this.props.lockerId, (resp) => {

            console.log(JSON.stringify(resp));

            let { files } = this.state;

            files = [];

            if (resp?.data) {
    
            resp.data.forEach((arquivo, index) => {
                files.push([
                    this.formatDate(arquivo.createdAt),
                    arquivo.fileName,
                    <a href={arquivo.url} target="_blank" download>{arquivo.url}</a>,
                    arquivo.type,
                    <Button onClick={() => this.handleResend(arquivo)} color="primary" autoFocus>
                             <Send />
                    </Button>
                ])
            })
        }
    
            files = files.length > 0 ? files : [["Nenhum arquivo encontrado", "", ""]];
    
            this.setState({ files, circular: false })

        });

    }

    render() {
        const { classes, lockerName, show } = this.props;
        let { open, fileType, openSnackbar, success, message, url, fileName, page, rowsPerPage, files } = this.state;
        const { circular } = this.state

        if (!show) return null;

        // this.handleFileRefresh();

        return (
            <>
                <Snackbar
                    place="tc"
                    color={success}
                    icon={AddAlert}
                    message={message}
                    open={openSnackbar}
                    closeNotification={this.handleClose}
                    close
                />
                <Card>
                    <CardHeader color="primary">
                        <h4>Gerenciamento de arquivos</h4>
                        <p>Locker: {lockerName}</p>
                    </CardHeader>
                    <CardBody>
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                                <h4>Receber Arquivos do Locker</h4>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <FormControl className={[classes.alItems, { marginBottom: 10 }]}>
                                    <InputLabel  htmlFor="fileTypeSelect">Tipo de arquivo</InputLabel>
                                    <Select
                                        id="fileTypeSelect"
                                        name="fileType"
                                        open={open}
                                        onClose={this.handleClose}
                                        onOpen={this.handleOpen}
                                        value={fileType}
                                        onChange={(e) => this.handleChange(e)}
                                    >

                                        <MenuItem value="">
                                            <em>-</em>
                                        </MenuItem>
                                        <MenuItem value="log.txt">log.txt</MenuItem>
                                        <MenuItem value="config.json">config.json</MenuItem>
                                        <MenuItem value="condominos.csv">condominos.csv</MenuItem>
                                        <MenuItem value="condominos_ativo.csv">condominos_ativo.csv</MenuItem>
                                        <MenuItem value="eventLog.txt">eventLog.txt</MenuItem>
                                        <MenuItem value="logcorreios.txt">logcorreios.txt</MenuItem>
                                    </Select>

                                </FormControl>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <FormControl className={classes.inputText}>
                                    <InputLabel htmlFor="fileTypeEdit">Nome do Arquivo</InputLabel>
                                    <Input
                                        id="fileTypeEdit"
                                        name="fileType"
                                        value={fileType}
                                        onChange={(e) => this.handleChange(e)}
                                    />
                                </FormControl>

                            </GridItem>
                            <GridItem xs={12} sm={12} md={2}>
                                <Button onClick={this.handleUpload} color="primary" autoFocus>
                                    {!circular ? "Buscar": <Circular size={20} style={{
                                              color: '#ffffff',
                                          }}/>}
                                </Button>
                            </GridItem>
                        </GridContainer>
                    </CardBody>
                </Card>

                <Card>
                    <CardBody>
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                                <h4>Envio de Arquivos</h4>
                            </GridItem>

                            <GridItem xs={12} sm={12} md={12}>
                                <FormControl className={classes.inputText}>
                                    <InputLabel htmlFor="url">URL</InputLabel>
                                    <Input type="file" onChange={this.handleFileChange} />
                                </FormControl>
                            </GridItem>

                            <GridItem xs={12} sm={12} md={12}>
                                <FormControl className={classes.inputText}>
                                    <InputLabel htmlFor="url">URL</InputLabel>
                                    <Input
                                        id="url"
                                        name="url"
                                        value={url}
                                        onChange={(e) => this.handleChange(e)}
                                    />
                                </FormControl>
                            </GridItem>

                            <GridItem xs={12} sm={12} md={12}>
                                <FormControl className={classes.inputText}>
                                    <InputLabel htmlFor="fileName">Nome do Arquivo</InputLabel>
                                    <Input
                                        id="fileName"
                                        name="fileName"
                                        value={fileName}
                                        onChange={(e) => this.handleChange(e)}
                                    />
                                </FormControl>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <Button onClick={this.handleDownload} color="primary" autoFocus>
                                    Enviar
                                </Button>
                            </GridItem>
                        </GridContainer>
                    </CardBody>
                </Card>


                <Card>
                    <CardBody>
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                                <GridItem xs={12} sm={12} md={6}>
                                    <h4>Lista de Arquivos</h4>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={6}>
                                    <Button onClick={this.handleFileRefresh} color="primary" autoFocus>
                                        Atualizar Lista
                                    </Button>
                                </GridItem>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                { 
                                    circular ? (
                                        <Circular/>
                                    ) : (
                                        <>
                                            <Table
                                                tableHeaderColor="primary"
                                                tableHead={["Data", "Arquivo", "URL", "Tipo", "Reenviar"]}
                                                tableData={this.state?.files?.slice(
                                                    page * rowsPerPage,
                                                    page * rowsPerPage + rowsPerPage,
                                                  )}
                                            />
                                            <TablePagination
                                                rowsPerPageOptions={[10, 25, 50]}
                                                component="div"
                                                count={files?.length}
                                                rowsPerPage={rowsPerPage}
                                                page={page}
                                                onChangePage={this.handleChangePage}
                                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                />
                                        </>
                                    )
                                }
                            </GridItem>
                        </GridContainer>
                    </CardBody>
                </Card>
            </>
        );
    }
}

export default withStyles(useStyles)(File);